import React from 'react';

import { Chip } from '@mui/material';
import moment from 'moment';

import { MISC_DATE_POLISH_DATE_ONLY_FORMAT } from '../../../../core/constants';
import { WarehouseTypeEnum } from '../../../../core/enums/inventory/warehouse';
import { getWarehouseName } from '../../../common/utils/warehouse_utils';

// batches expiring within this many days are highlighted as needing attention
export const EXPIRING_SOON_DAYS = 2;

const currencyFormatter = new Intl.NumberFormat('pl-PL', { style: 'currency', currency: 'PLN' });
const numberFormatter = new Intl.NumberFormat('pl-PL');

export const formatCurrency = (value) => value === null || value === undefined ? '-' : currencyFormatter.format(value);
export const formatNumber = (value) => value === null || value === undefined ? '-' : numberFormatter.format(value);
export const formatDate = (date) => date ? moment(date).format(MISC_DATE_POLISH_DATE_ONLY_FORMAT) : '-';

export const getBatchValue = (batch) => batch?.purchaseNetPrice === null || batch?.purchaseNetPrice === undefined
    ? null
    : Number(batch.purchaseNetPrice) * batch.quantity;

// ILUO can report stock in a location that is not one of the store warehouses
export const getStockLocationName = (warehouse, warehouseId) => warehouse ? getWarehouseName(warehouse) : `Nieprzypisana lokalizacja #${ warehouseId }`;

const warehouseTypeLabels = {
    [WarehouseTypeEnum.MAIN.value]: 'Główny',
    [WarehouseTypeEnum.INVENTORY.value]: 'Inwentaryzacyjny',
    [WarehouseTypeEnum.POD.value]: 'Pod',
    [WarehouseTypeEnum.POP.value]: 'Pop'
};

export const getWarehouseTypeLabel = (warehouse) => warehouseTypeLabels[warehouse?.type] || 'Inny';

export const isExpiringSoon = (date) => {
    if (!date) return false;
    const days = moment(date).startOf('day').diff(moment().startOf('day'), 'days');
    return days >= 0 && days <= EXPIRING_SOON_DAYS;
};

export const ExpirationChip = ({ date, expired }) => {
    if (!date) return '-';

    if (expired) {
        return <Chip size="small" color="error" label={ `${ formatDate(date) } · przeterminowane` }/>;
    }

    if (isExpiringSoon(date)) {
        return <Chip size="small" color="warning" label={ formatDate(date) }/>;
    }

    return <Chip size="small" variant="outlined" label={ formatDate(date) }/>;
};
